// A student who opens an AI app's "Connect Shovel" link while signed out signs in first; this remembers the request
// so the login can bring them back to it instead of the calendar.
const KEY = 'pendingAgentConnect';

export const rememberAgentConnect = (requestId: string) => {
  try {
    sessionStorage.setItem(KEY, requestId);
  } catch (e) {
    // Private mode or blocked storage: they land on the calendar and can start again from the AI app.
  }
};

export const takeAgentConnect = (): string | null => {
  try {
    const requestId = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return requestId;
  } catch (e) {
    return null;
  }
};

/** Whether a signed-out student came from an AI app (the phone web app only shows its login for them). */
export const hasPendingAgentConnect = (): boolean => {
  try {
    return !!sessionStorage.getItem(KEY);
  } catch (e) {
    return false;
  }
};
